export default __webpack_public_path__ + "static/home-b682786fe78c85a10b4accb23111e67e.mp4";